import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DocumentCreateModel, DocumentModel } from '@data-layer/models/documents';
import { ValidationMessageModel } from '@data-layer/models/common';
import {
  MISSING_ATTACHED_DOCUMENT_BILL_OF_LADING,
  MISSING_ATTACHED_DOCUMENT_INVOICE,
  MISSING_ATTACHED_DOCUMENT_PUN,
} from '@constants/entity-validation-messages';
import { enumDocumentState, enumDocumentType } from '@data-layer/enums/documents';
import { Observable } from 'rxjs';
import { finalize, take } from 'rxjs/operators';
import { IEsDocumentStateUpdate } from '../../interfaces';
import { POA_FILE_URL } from '@constants/constants';

@Component({
  selector: 'es-pun-document-download',
  templateUrl: './es-pun-document-download.component.html',
  styleUrls: ['./es-pun-document-download.component.scss'],
})
export class EsPunDocumentDownloadComponent {
  @Input() public document: DocumentModel;
  @Input() public isCanUploadDocuments: boolean;
  @Input() public isCanRemoveDocuments: boolean = false;
  @Input() public canUploadPunToCompany: boolean = true;
  @Input() public validationMessages: ValidationMessageModel[] = [];
  @Input() public attachmentTypeName: string;
  @Input() public attachmentName: string;
  @Input() public attachmentHint: string;

  @Input() public upload: (document: DocumentCreateModel, file: File, uploadToCompany: boolean) => Observable<any>;
  @Input() public remove: (documentId: number) => Observable<any>;
  @Output() public stateUpdate: EventEmitter<IEsDocumentStateUpdate> = new EventEmitter<IEsDocumentStateUpdate>();

  public isOpenPunModal: boolean = false;
  public isLoading: boolean = false;

  public POA_FILE_URL: string = POA_FILE_URL;

  private punFile: File;

  constructor() {}

  public get isRequiredDocument(): boolean {
    return !!this.validationMessages.find(
      (message) =>
        ((message.text === MISSING_ATTACHED_DOCUMENT_INVOICE && this.document.type === enumDocumentType.INVOICE) ||
          (message.text === MISSING_ATTACHED_DOCUMENT_BILL_OF_LADING && this.document.type === enumDocumentType.BILL_OF_LADING) ||
          (message.text === MISSING_ATTACHED_DOCUMENT_PUN && this.document.type === enumDocumentType.ACH_APPROVAL)) &&
        message.params &&
        message.params.relatedEntityId === this.document.relatedEntityId,
    );
  }

  public onStateUpdate(state: enumDocumentState) {
    this.stateUpdate.emit({ documentId: this.document.id, state });
  }

  public onRemoveFile(event: DocumentModel): void {
    if (!this.isCanRemoveDocuments || !this.remove) {
      return;
    }
    this.isLoading = true;
    this.remove(event.id)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        }),
        take(1),
      )
      .subscribe();
  }

  public openPunModal(file: File) {
    if (!this.upload) {
      return;
    }
    this.punFile = file;
    if (this.canUploadPunToCompany) {
      this.isOpenPunModal = true;
    } else {
      this.onUploadPunFile(false);
    }
  }

  public onUploadPunFile(uploadToCompany: boolean) {
    if (!this.upload) {
      return;
    }
    const createDocument: DocumentModel = { ...this.document, fileName: this.punFile.name };
    this.isOpenPunModal = false;
    this.isLoading = true;
    this.upload(createDocument, this.punFile, uploadToCompany)
      .pipe(
        finalize(() => {
          this.punFile = null;
          this.isLoading = false;
        }),
        take(1),
      )
      .subscribe(() => {});
  }
}
